// Keep QUICK_LINK_KEYS in sync with KEYS in dioscuro/functions/lib/quickLinks.js;
// cross-runtime parity is enforced by functions/lib/__tests__/quickLinksParity.test.js.
// Role ordering mirrors ROLE_RANK in dioscuro/src/context/AuthContext.js (hasRole).
// hasRole is not imported here because AuthContext has React/firebase side-effects;
// instead we replicate the identical rank-index logic (same order: public < client < staff < admin).

const ROLE_ORDER = ["public", "client", "staff", "admin"];

export const QUICK_LINKS = [
  { key: "profile",       label: "Profile",           path: "/profile",              requiredRole: "public" },
  { key: "notifications", label: "Notifications",     path: "/notifications",        requiredRole: "public" },
  { key: "guide",         label: "Guide",             path: "/guide",                requiredRole: "public" },
  { key: "career",        label: "Career path",       path: "/career-path",          requiredRole: "public" },
  { key: "labs",          label: "Labs",              path: "/labs",                 requiredRole: "public" },
  { key: "academy",       label: "Academy",           path: "/academy",              requiredRole: "public" },
  { key: "staffing",      label: "Staffing",          path: "/staffing",             requiredRole: "public" },
  { key: "infrastructure",label: "Infrastructure",    path: "/infrastructure",       requiredRole: "client" },
  { key: "time-tracker",  label: "Time tracker",      path: "/time-tracker",         requiredRole: "staff" },
  { key: "tools",         label: "Tools",             path: "/tools",                requiredRole: "public" },
  { key: "mentor",        label: "Mentor dashboard",  path: "/mentor-dashboard",     requiredRole: "staff",  requiredTag: "mentor" },
  { key: "leads",         label: "Leads",             path: "/sales-leads",          requiredRole: "staff",  requiredTag: "sales" },
  { key: "outreach",      label: "Outreach",          path: "/sales",                requiredRole: "staff",  requiredTag: "sales" },
  { key: "sales-dashboard",label: "Leads dashboard",  path: "/sales-dashboard",      requiredRole: "staff",  requiredTag: "sales" },
  { key: "admin",         label: "User management",   path: "/admin",                requiredRole: "admin" },
  { key: "audit",         label: "Audit log",         path: "/admin-audit",          requiredRole: "admin" },
  { key: "projects",      label: "Projects",          path: "/admin-projects",       requiredRole: "admin" },
  { key: "paths",         label: "Learning paths",    path: "/admin-paths",          requiredRole: "admin" },
  { key: "lesson-videos", label: "Lesson videos",     path: "/admin-lesson-videos",  requiredRole: "admin" },
];

export const QUICK_LINK_KEYS = QUICK_LINKS.map((q) => q.key);

export const DEFAULT_QUICK_LINKS = ["profile", "admin", "audit", "leads", "outreach", "notifications", "tools"];

// Mirrors hasRole from src/context/AuthContext.js (ROLE_RANK rank-index comparison).
// `role` is always one of ROLE_ORDER (userDoc.role || "public"); an unknown
// string would indexOf to -1 and fail closed (link hidden) — safe by design.
// Admin bypasses requiredTag (matches canAccessMentor/canAccessSales pattern).
export const canUseQuickLink = (link, role, tags) => {
  const roleOk =
    ROLE_ORDER.indexOf(role || "public") >= ROLE_ORDER.indexOf(link.requiredRole);
  const tagOk = role === "admin" || !link.requiredTag || (Array.isArray(tags) && tags.includes(link.requiredTag));
  return roleOk && tagOk;
};
